import { render, staticRenderFns } from "./DNDPlaceholder.vue?vue&type=template&id=0964caef&scoped=true&"
import script from "./DNDPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./DNDPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./DNDPlaceholder.vue?vue&type=style&index=0&id=0964caef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0964caef",
  null
  
)

export default component.exports